import * as React from "react";
import useProductName from "brand-customization/useProductName";
import { Alert, Button } from "components/bootstrap";
import { Icon } from "components/common";
import LicenseHelp from "license/notifications/LicenseHelp";
const LicenseTrialNotification = ({ expiresIn, onMuteClick }) => {
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info", className: "has-bm", title: `${productName} Enterprise Trial License` }, /* @__PURE__ */ React.createElement("p", null, "Your trial license will expire in ", /* @__PURE__ */ React.createElement("strong", null, expiresIn), ". ", /* @__PURE__ */ React.createElement(LicenseHelp, null), /* @__PURE__ */ React.createElement(Button, { bsSize: "xsmall", className: "pull-right", onClick: onMuteClick }, /* @__PURE__ */ React.createElement(Icon, { name: "close" }), " Remind me later")));
};
export default LicenseTrialNotification;
